<template>
  <div v-if="ordreTravail && anneeSemaine">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" >
                {{ $t('affectationOrdreTravailAffichage.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="mgt-20px column is-12 column is-narrow">
        <div class="column is-4 is-paddingless">
          <div class="card height-100">
            <div class="card-content">
              <p class="has-text-weight-bold">
                {{ $t('affectationOrdreTravailAffichage.informationOt.title',
                { code: ordreTravail.code}) }}</p>
              <p class="has-text-default is-size-7 mgt-10px">
                {{ $t('affectationOrdreTravailAffichage.informationOt.listeAffichage',
                { listeAffichage: ordreTravail.tourneeAffichage }) }}</p>
              <p class="has-text-default is-size-7 mgt-10px">
                {{ $t('affectationOrdreTravailAffichage.informationOt.dateDepart',
                { date: getDate(ordreTravail.dateDepart) }) }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mgt-20px column is-12 overflow-x-hidden" v-if="filtres.otId">
        <tab-tournee-face-semaine :ref="referenceTable"
                                  :referenceTable="referenceTable"
                                  :filtres="filtres"
                                  :actions="actions"
                                  :anneeSemaine="anneeSemaine"
                                  :typeDonnee="constantes.EXPORT_EXCEL_AFFECTATION_LOGISTIQUE">
        </tab-tournee-face-semaine>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/api/logistique/ordreTravailAffichage';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import tabTourneeFaceSemaine from '@/components/logistique/affectation/tabTourneeFaceSemaine';
import {
  ACTION_AFFICHAGE, ACTION_INSTRUCTION_POSE, ACTION_LAISSER_EN_PLACE,
  ACTION_ENLEVER_LAISSER_EN_PLACE, EXPORT_EXCEL_AFFECTATION_LOGISTIQUE,
} from '@/configuration/logistique/facesDisponible/facesDisponibleConf';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import formatDate from '@/services/general/formatDate';
import { REFERENCE_TABLE_GESTION_AFFECTATIONS } from '@/configuration/general/referenceTableConf';

export default {
  name: 'm_affectationLogistique',
  data() {
    return {
      ordreTravail: null,
      anneeSemaine: null,
      affectations: [],
      filtres: {
        otId: null,
      },
      constantes: {
        EXPORT_EXCEL_AFFECTATION_LOGISTIQUE,
      },
      actions: [
        { action: ACTION_AFFICHAGE, translation: 'faceDisponible.actions.actionAffichage' },
        { action: ACTION_INSTRUCTION_POSE, translation: 'faceDisponible.actions.instructionPose' },
        { action: ACTION_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.laisserEnPlace' },
        { action: ACTION_ENLEVER_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.enleverLaisserEnPlace' },
      ],
      referenceTable: REFERENCE_TABLE_GESTION_AFFECTATIONS,
    };
  },
  components: {
    breadcrumb,
    tabTourneeFaceSemaine,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('affectationOrdreTravailAffichage.breadcrumb.detailOrdreTravailAffichage'), route: { name: 'c.logistique.ordre_travail-affichage', params: { id: this.ordreTravail.id } }, isActive: false },
        { title: this.$i18n.t('affectationOrdreTravailAffichage.breadcrumb.affectationLogistique'), route: '', isActive: true },
      ];
    },
  },
  methods: {
    getDate(date) {
      return formatDate(date);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.ordreTravail = (await get(this.$route.params.id)).data.result;
      this.anneeSemaine = Number(getAnneeSemaineFromDate(this.ordreTravail.dateDepart));
      this.filtres.otId = this.ordreTravail.id;
      this.setInformationPage(this.$t('pageLogistique.ot.affectationLogistique'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
